/* global $, MatgenGlobal */

import { init as keysInit } from './key-events.js';
//import { init as userKeysInit } from './user-key-events.js';
import { emit } from '../../util/helpers.js';
import { initIconPicker } from '../ui/ui-functions.js';

function genericClickHandler(e) {
  if (!MatgenGlobal.SuppressTooltips) {
    $('[data-bs-toggle="tooltip"]').tooltip('hide');
    MatgenGlobal.hideTooltips();
    //$('[data-bs-toggle="dropdown"]').dropdown('hide');
  } else {
    MatgenGlobal.hideTooltips();
    //$('.m4c-matgen .dropdown-menu').hide();
  }

  if (
    e.target.tagName !== 'CANVAS' &&
    MatgenGlobal.editor &&
    MatgenGlobal.editor.cur() &&
    $(e.target).parents('.tree-li').length === 0
  ) {
    MatgenGlobal.editor.cur().hoverOutline(e, true);
    MatgenGlobal.editor.cur().fabric.discardActiveObject();
    MatgenGlobal.editor.cur().fabric.requestRenderAll();
  }
}

const decode = str => {
  return $('<textarea/>')
    .html(str)
    .text();
};

/*function commonNavHandler() {
  //console.log('MATGEN NAVIGATION:');
  //MatgenGlobal.navigating = e;
  //console.log('REMOVE SIDEBAR');
  console.error(new Error());
  $('#sidebar').remove();
}*/

const init = () => {
  //console.error('EDITOR EVENTS INIT');
  /*if (!MatgenGlobal.editor) {
    return false;
  }*/

  $(document).off('click', '#toggle-icon-chooser');
  $(document).on('click', '#toggle-icon-chooser', () => {
    initIconPicker();
  });

  $(document).off('change', 'select');
  $(document).on('change', 'select', e => {
    if (
      $(e.currentTarget)
        .find('option:selected')
        .hasClass('default')
    ) {
      $(e.currentTarget).css('color', '#aaa');
    } else {
      $(e.currentTarget).css('color', 'inherit');
    }
  });

  $(document).on('show.bs.modal, show-page', () => {
    $('select').each((i, el) => {
      if (
        $(el)
          .find('option:selected')
          .hasClass('default')
      ) {
        $(el).css('color', '#aaa');
      } else {
        $(el).css('color', 'inherit');
      }
    });
  });

  $(document).off('matgen-signin');
  $(document).on('matgen-signin', () => {
    MatgenGlobal.CommonInit();
    MatgenGlobal.EditorInit();
  });

  $(document).off('matgen-canvas-mouse-out');
  $(document).on('matgen-canvas-mouse-out', async e => {
    MatgenGlobal.editor.cur().hoverOutline(e, true);
  });

  /*$(document).on('matgen-navigation', () => {
    console.error('MATGEN NAVIGATION:');
  });*/

  $(document).off('click', genericClickHandler);
  $(document).on('click', genericClickHandler);

  if (
    MatgenGlobal.AuthUser &&
    MatgenGlobal.AuthUser.getUserRole() === 'super'
  ) {
    keysInit();
  }

  $(document).off('object-left-click');
  $(document).off('object-right-click');
  if (
    MatgenGlobal.AuthUser &&
    MatgenGlobal.AuthUser.getUserRole() === 'super'
  ) {
    $(document).on(
      'object-right-click',
      MatgenGlobal.containerSelector,
      async e => {
        if (e.detail.canvasEvent.target.type === 'textbox') {
          e.preventDefault();
          MatgenGlobal.UI.textForm({
            edit: true,
            id: e.detail.canvasEvent.target.id,
          });
        }
      }
    );
  } else if (
    MatgenGlobal.AuthUser &&
    MatgenGlobal.AuthUser.getUserRole() === 'admin'
  ) {
    $(document).on('object-left-click', () => {
      if ($('#context-menu').length > 0 && !window.contextMenu) {
        $('#context-menu').remove();
      } else {
        window.contextMenu = false;
      }
    });

    $(document).on(
      'object-left-click',
      MatgenGlobal.containerSelector,
      async () => {
        const curObj = MatgenGlobal.editor.cur().fabric.getActiveObject();
        console.log(
          'HANDLE LEFT CLICK',
          curObj,
          MatgenGlobal.containerSelector
        );
        if (curObj && curObj.componentId) {
          await MatgenGlobal.UI.showComponentOptions(curObj.componentId);
        } else if (curObj.userEditable) {
          MatgenGlobal.UI.alertModal(
            'User Editable Text Component',
            '<p>This is a user editable text component. No actions available.</p>'
          );
        } else if (curObj.uploader) {
          MatgenGlobal.UI.alertModal(
            'User Image Uploader Component',
            '<p>This is a user image uploader component. No actions available.</p>'
          );
        }
      }
    );
  } else if (
    MatgenGlobal.AuthUser &&
    (!MatgenGlobal.AuthUser.user ||
      MatgenGlobal.AuthUser.getUserRole() === 'user')
  ) {
    $(document).on(
      'object-left-click',
      MatgenGlobal.containerSelector,
      async e => {
        const curObj = MatgenGlobal.editor.cur().fabric.getActiveObject();
        //console.error('USER LEFT CLICK', curObj);
        if (
          e.detail.canvasEvent.target.type === 'textbox' &&
          e.detail.canvasEvent.target.editable &&
          (!curObj || !curObj.studyDataConnection)
        ) {
          //console.log('TEXTBOX');
          MatgenGlobal.UI.userTextForm(e.detail.canvasEvent.target.id);
        } else if (e.detail.canvasEvent.target.uploader) {
          //console.log('UPLOADER');
          const isQR =
            e &&
            e.detail &&
            e.detail.canvasEvent &&
            e.detail.canvasEvent.target &&
            e.detail.canvasEvent.target.isQRGenerator;

          const uploaderType = isQR ? 'generator' : 'file';
          MatgenGlobal.UI.userUpload(false, uploaderType);
        } else if (curObj && curObj.componentId && curObj.hasOptions) {
          //console.log('COMPONENT');
          await MatgenGlobal.UI.showComponentOptions(curObj.componentId);
        } else if (curObj && curObj.studyDataConnection) {
          //console.log('STUDY DATA');
          if (curObj.type === 'textbox') {
            let studyData =
              MatgenGlobal.microsite_vars[curObj.studyDataConnection];

            const joinData = ['primary_contact', 'health_status'];
            if (joinData.includes(curObj.studyDataConnection)) {
              studyData = studyData.join('\n');
            } else if (curObj.studyDataConnection === 'investigators') {
              studyData = MatgenGlobal.microsite_vars[
                curObj.studyDataConnection
              ][0]
                .map(o => {
                  return `${decode(o.name).replace(
                    ' (not required)',
                    ''
                  )}: ${decode(o.value)}`;
                })
                .join('\n');
            } else if (curObj.studyDataConnection === 'locations') {
              const states = Object.keys(
                MatgenGlobal.microsite_vars[curObj.studyDataConnection]
              );
              const output = [];
              for (let i = 0; i < states.length; i++) {
                output.push(states[i]);
                const locs =
                  MatgenGlobal.microsite_vars[curObj.studyDataConnection][
                    states[i]
                  ];
                for (let j = 0; j < locs.length; j++) {
                  const loc = locs[j];
                  for (let k = 0; k < loc.length; k++) {
                    const json = JSON.parse(loc[k].text);
                    output.push(`${json.label}: ${loc[k].userAnswer}`);
                  }
                  output.push('\n');
                }
                output.push('\n');
              }
              studyData = output.join('\n');
            } else if (curObj.studyDataConnection === 'faq') {
              studyData = MatgenGlobal.microsite_vars[
                curObj.studyDataConnection
              ]
                .map(o => `${o.text}: ${o.userAnswer}`)
                .join('\n\n');
            }

            MatgenGlobal.UI.userStudyDataTextForm(
              curObj.id,
              studyData,
              curObj.fontSize
            );
          } else if (curObj.type === 'image') {
            MatgenGlobal.UI.userUpload();
          }
        }
      }
    );
  }

  $(document).off('click', '.table-action');
  $(document).on('click', '.table-action', e => {
    e.preventDefault();
    const closest = $(e.target).closest('[data-action]');
    const action = closest.attr('data-action');
    const id = closest.attr('data-id');
    const alt_id = closest.attr('data-alt-id');
    const row = e.target.closest('tr');

    const data = closest.data();

    console.log(action, id, data);
    emit({
      event: 'matgen-table-action',
      detail: {
        action,
        id,
        row,
        alt_id,
        data,
      },
    });
  });

  $(document).off('click', '.thumb-page');
  $(document).on('click', '.thumb-page', async e => {
    MatgenGlobal.UI.loading('Loading preview...', '#preview-thumb');
    e.preventDefault();
    //console.log($(e.target).attr('data-tenant-id'), $(e.target));
    if ($(e.target).attr('data-tenant-id')) {
      const ext = '.png';
      $('#page-thumb').attr(
        'src',
        `${MatgenGlobal.Data.getTemplateFileURL(
          $(e.target).attr('data-id'),
          $(e.target).attr('data-tenant-id'),
          ext
        )}`
      );
    } else if ($(e.target).attr('data-page-id')) {
      $('#page-thumb').attr(
        'src',
        `${await MatgenGlobal.Data.getMaterialPreviewURL(
          $(e.target).attr('data-id'),
          $(e.target).attr('data-page-id')
        )}`
      );
    } else {
      throw new Error('Missing tenant or page ID');
    }
    $('#page-thumb')[0].onload = () => {
      MatgenGlobal.UI.stopLoading();
    };
    $('#page-thumb')[0].onerror = () => {
      MatgenGlobal.UI.stopLoading();
    };
  });

  $(document).off('mouseleave', MatgenGlobal.containerSelector);
  $(document).on('mouseleave', MatgenGlobal.containerSelector, () => {
    if (
      MatgenGlobal.editor &&
      MatgenGlobal.editor.cur() &&
      !MatgenGlobal.editor.cur().fabric.getActiveObject()
    ) {
      $('.tree-li').removeClass('active');
    }
  });

  $(document).off('selection-changed', MatgenGlobal.containerSelector);
  $(document).on('selection-changed', MatgenGlobal.containerSelector, e => {
    let objects = [e.detail.canvasEvent.target];
    if (e.detail.canvasEvent.target.getObjects) {
      objects = e.detail.canvasEvent.target
        .getObjects()
        .filter(o => !o.sidebarIgnore);
    }
    //objects.unshift(e.detail.canvasEvent.target);
    $('.tree-li').removeClass('active');
    //let badGroup = false;
    objects.forEach(o => {
      //console.log('OBJ:', o);
      $(`#${o.id}`).addClass('active');
      $(`#${o.componentId}`).addClass('active');
      $(`#gcid-${o.componentId}`).addClass('active');

      /*if (o.uploader || o.userEditable || o.componentId) {
        badGroup = true;
      }*/
    });

    /*if (objects.length > 1 && !badGroup) {
      $('#group-make-component')
        .show()
        .removeClass('btn-secondary')
        .addClass('btn-danger');
    } else {
      $('#group-make-component').hide();
    }*/
  });

  $(document).off('selection-cleared', MatgenGlobal.containerSelector);
  $(document).on('selection-cleared', MatgenGlobal.containerSelector, () => {
    //console.log(e);
    $('.tree-li').removeClass('active');
  });
};

export { init };
